import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { UserSettingsModels } from '@share-models';
import { UserSettingsActions } from '../../data-access/state/user-account-settings.actions';
import {
  EnableEscCloseDirective,
  UiButtonComponent,
  UiToggleComponent,
} from '@ui';
import { Store } from '@ngrx/store';
import { UserAccountSettingsState } from '../../data-access/state/user-account-settings.reducer';

@Component({
  selector: 'app-change-weekly-subscription-modal',
  standalone: true,
  imports: [
    MatDialogClose,
    TranslatePipe,
    ReactiveFormsModule,
    UiToggleComponent,
    UiButtonComponent,
  ],
  templateUrl: './change-weekly-subscription-modal.component.html',
  styleUrl: './change-weekly-subscription-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [EnableEscCloseDirective],
})
export class ChangeWeeklySubscriptionModalComponent implements OnInit {
  public weeklySubscriptionFormControl = new FormControl<boolean>(true, [
    Validators.required.bind(Validators),
  ]);

  private dialogRef = inject(
    MatDialogRef<ChangeWeeklySubscriptionModalComponent>,
  );
  private store$ = inject<Store<UserAccountSettingsState>>(Store);
  public data = inject<{ settings: UserSettingsModels.UserSettingsDocument }>(
    MAT_DIALOG_DATA,
  );

  public ngOnInit(): void {
    this.weeklySubscriptionFormControl.patchValue(
      this.data?.settings?.subForWeekly ?? true,
    );
  }

  public close(): void {
    this.dialogRef.close();
  }

  public save(): void {
    const formValue = this.weeklySubscriptionFormControl.value ?? true;
    this.store$.dispatch(
      UserSettingsActions.startUpdateWeeklySubscription({
        subForWeekly: formValue,
      }),
    );
    this.dialogRef.close();
  }
}
